// extracted by mini-css-extract-plugin
export default {"innerWrapper":"iv-z","tooltipWrapper":"jv-z","icon":"kv-z","tooltip":"lv-z","content":"mv-z"};